import React from 'react';
import { cx } from '../cx';

// D-09 §15.30 — Skeleton (.skel · width/height 는 style 로 지정)
// variant: block(기본 <div>) | text(텍스트 흐름 내 인라인 <span>, .skel-text) | circle(원형, .skel-circle)
//        | chip(아이콘 칩 자리표시, .skel-chip — 치수·모서리를 클래스가 가지므로 width/height 불필요)
export interface SkeletonProps extends React.HTMLAttributes<HTMLElement> {
  width?: string | number;
  height?: string | number;
  variant?: 'block' | 'text' | 'circle' | 'chip';
}

export function Skeleton({
  width,
  height,
  variant = 'block',
  className = '',
  style,
  ...props
}: SkeletonProps) {
  const Tag = variant === 'text' ? 'span' : 'div';
  return (
    <Tag
      className={cx('skel', variant !== 'block' && `skel-${variant}`, className)}
      style={{ width, height, ...style }}
      {...props}
    />
  );
}
